import type { AccountSummary, HealthState } from '@crosscastr/shared';

/** Human label + cap-bar colour for a health state (color is paired with this label, never alone). */
export function stateMeta(a: AccountSummary): { cls: HealthState; label: string; capColor: string } {
  const capColor = `var(--${a.healthState === 'muted' ? 'muted' : a.healthState})`;
  let label: string;
  switch (a.healthState) {
    case 'ok':
      label = a.warmUpStage >= 5 ? 'בריא · בוגר' : 'בריא';
      break;
    case 'warm':
      label = `בהרצה · שלב ${a.warmUpStage}`;
      break;
    case 'risk':
      label = a.status === 'paused' ? 'בסיכון · הושהה' : 'בסיכון';
      break;
    default:
      label = a.status === 'qr' ? 'בהתחברות' : 'מנותק';
  }
  return { cls: a.healthState, label, capColor };
}

/** Warm-up stage → short human value ("מלא" once graduated). */
export const warmUpValue = (stage: number): string => (stage >= 4 ? 'מלא' : `${stage} / 4`);
